import React, { useCallback, useEffect, useState } from 'react';
// import NotificationDropdown from './NotificationDropdown';
import UserDropdown from './Profile/UserDropdown';
import ProjectLists from './ProjectLists';
import { useApp, useCommon, usePermission, useUser } from 'hooks';
import { ROUTES } from 'utils';
import { EActionUserModal, EModeVideProject, ETaskActions } from 'types';
import { useNavigate } from 'react-router-dom';
import { Funnel, MoveLeft, Plus } from 'lucide-react';

export default function Topbar() {
    const { isAdmin } = usePermission()
    const { onUpdateParams, loadInitialData, projectIsFetch, userIsFetch, taskDetailIsFetch } = useApp();
    const { setListProjects, defaultProject } = useUser();

    const router = useNavigate();
    const [view, setView] = useState(EModeVideProject.list); // kanban, list, gantt
    const [show, setShow] = useState(false);
    const currentRoute = useCommon(state => state.currentRoute);
    const { setCurrentRoute, setBoardState, setActionsUserState, setActionsTaskState, actionsTaskState } = useCommon();
    const pathname = window.location.pathname;
    const segments = pathname.split("/");

    useEffect(() => {
        (async () => {
            const { projects, users } = await loadInitialData();
            onUpdateParams({ userData: users, projectData: projects });
            setListProjects(projects?.data ?? [])
        })();
    }, [projectIsFetch, userIsFetch, taskDetailIsFetch]);

    // useEffect(() => {
    //     setBoardState(EModeVideProject.list)
    // }, []);

    useEffect(() => {
        setView(EModeVideProject.list)
        setBoardState(EModeVideProject.list)
        setCurrentRoute(pathname);
        setActionsTaskState({ method: null })
    }, [pathname]);

    const handleModeView = (v) => {
        setView(v)
        setBoardState(v);
        setActionsTaskState({ method: null });
        v !== view && onUpdateParams({ taskDetail: null });
    }

    const showFilterPopup = () => {
        setShow(s => !s)
        setActionsTaskState({ method: { [ETaskActions.SHOW_FILTER]: !show } })
    }

    useEffect(() => {
        if (!actionsTaskState) {
            showFilterPopup();
        }
    }, [actionsTaskState]);

    const renderActions = useCallback(() => {
        switch (currentRoute) {
            case ROUTES.PRIVATE_ROOT.PROJECTS:
                return isAdmin ? (<div className="flex items-center justify-between">
                    <button className="bg-red-500 text-white px-4 py-2 rounded-md text-sm" onClick={() => router(ROUTES.PRIVATE_ROOT.PROJECTS_CREATE)}>
                        + Thêm dự án
                    </button>
                </div>) : <></>;

            case ROUTES.PRIVATE_ROOT.USERS:
                return (<button className="bg-red-500 text-white px-4 py-2 rounded text-sm" onClick={() => setActionsUserState({ method: EActionUserModal.CREATE })}>+ Thêm thành viên</button>);

            case ROUTES.PRIVATE_ROOT.TASKS:
                return defaultProject ? (<div className="flex items-center space-x-4">
                    <div className="flex space-x-2">
                        <button
                            onClick={() => handleModeView(EModeVideProject.list)}
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${view === EModeVideProject.list
                                ? 'bg-blue-500 text-white'
                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                        >
                            List
                        </button>
                        <button
                            onClick={() => handleModeView(EModeVideProject.kanban)}
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${view === EModeVideProject.kanban
                                ? 'bg-blue-500 text-white'
                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                        >
                            Board
                        </button>
                        <button
                            onClick={() => handleModeView(EModeVideProject.gantt)}
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${view === EModeVideProject.gantt
                                ? 'bg-blue-500 text-white'
                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                        >
                            Gantt Chart
                        </button>
                    </div>
                </div>) : <></>

            default:
                break;
        }
    }, [currentRoute, view, defaultProject]);

    return (
        <div className="h-14 border-b border-gray-200 px-6 flex items-center justify-between">
            <div className="flex items-center space-x-4">
                {(segments.includes("create") || segments.includes("edit") || segments.includes("detail")) && <div>
                    <button
                        onClick={() => router(-1)}
                        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${view === EModeVideProject.gantt
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                    >
                        <MoveLeft />
                    </button>
                </div>}
                {renderActions()}
            </div>
            <div className="flex gap-2 items-center">
                {currentRoute === ROUTES.PRIVATE_ROOT.TASKS && defaultProject &&
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={() => showFilterPopup()}
                            className="bg-gray-200 text-gray px-4 py-2 rounded text-sm flex items-center space-x-2 mr-2"
                        >
                            <Funnel size={22} color='blue' />
                        </button>

                        <button
                            onClick={() => setActionsTaskState({ method: ETaskActions.ADD })}
                            className="bg-red-500 text-white px-2 py-2 rounded text-sm flex items-center space-x-2 mr-2"
                        >
                            <Plus size={16} />
                            <span>Thêm nhiệm vụ</span>
                        </button>
                    </div>}
                {/* <div className="flex -space-x-2 px-1">
                    <ProjectLists />
                </div> */}
                {/* <div className="flex -space-x-2 px-1">
                    <NotificationDropdown />
                </div> */}
                <div className="flex -space-x-2">
                    <UserDropdown />
                </div>
            </div>
        </div>
    );
}